import { usePathname } from "next/navigation";

import { HeaderLogo } from "./header-logo";
import { HeaderSearch } from "./header-search";

export function Header() {
  const pathname = usePathname();

  return (
    <header
      data-slot="layout-header"
      data-debug-source="components/layouts/layout-30/components/header.tsx"
      className="fixed start-0 end-0 top-0 z-10 flex h-(--header-height) shrink-0 items-stretch border-b border-zinc-800 bg-black pe-[var(--removed-body-scroll-bar-size,0px)] text-zinc-100"
    >
      <div className="container-fluid flex min-w-0 grow items-stretch gap-2 sm:gap-3">
        <div className="flex min-w-0 flex-1 items-stretch">
          <HeaderLogo />
        </div>
        <div
          data-slot="header-utilities"
          data-debug-source="components/layouts/layout-30/components/header.tsx"
          className="flex shrink-0 items-center gap-1 border-s border-zinc-800 ps-2 sm:gap-2 sm:ps-3"
        >
          <HeaderSearch key={pathname} />
        </div>
      </div>
    </header>
  );
}
